module.exports = __webpack_public_path__ + "img/Zimmer.6c5c23be.jpg";